import { gql } from '@apollo/client';

export const ADD_ATTENDEES_TO_ACTIVITY = gql`
  mutation addAttendeesToActivity($input: AddAttendeesToActivityInput!) {
    activity: addAttendeesToActivity(input: $input) {
      id
    }
  }
`;
